define.alias("ember-intl/helpers/format-date", "media/helpers/format-date");